module.exports = __webpack_public_path__ + "static/img/symbol-neofect-white.7d704107.svg";